import { httpClient } from '../httpClient';
export class CustomerRepository {
    // 契約者情報取得
    async getCustomer() {
        const { data } = await httpClient.get(`customer/fetch`);
        return data;
    }
    // 契約者住所情報取得
    async getCustomerAddressInfo() {
        const { data } = await httpClient.get(`customer/address-info/fetch`);
        return data;
    }
    // 契約者情報変更（名義人変更）
    async changeCustomerName(params) {
        const { data } = await httpClient.post(`customer/name-change`, JSON.stringify({
            sei: params.sei,
            mei: params.mei,
            seiKana: params.seiKana,
            meiKana: params.meiKana,
            reason: params.reason
        }));
        return data;
    }
}
